// extracted by mini-css-extract-plugin
export default {"timeGridCell":"RenderEventBlocks_timeGridCell__9bWBw","pastCalendarCell":"RenderEventBlocks_pastCalendarCell__DPwzP"};